// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginStyle_login__3a2VZ","headers":"LoginStyle_headers__1XsJZ","imageContainer":"LoginStyle_imageContainer__2mRjj","logo":"LoginStyle_logo__3hcR9"};